export const LOREN_USER_ROLES = {
  ADMIN: "ROLE_ADMIN_FULL",
  ADMIN_READ: "ROLE_ADMIN_READ",
  USER: "ROLE_USER",
  TEST: "ROLE_TEST",
  COMPANY_ADMIN: "ROLE_COMPANY_ADMIN",
  CHANNEL_ADMIN: "ROLE_CHANNEL_ADMIN",
  CHANNEL_ADMIN_READ: "ROLE_CHANNEL_ADMIN_READ",
};

export const LOREN_USER_CLIENT_ROLES = {
  CLIENT_USER: "ROLE_CLIENT_USER",
  CLIENT_ADMIN: "ROLE_CLIENT_ADMIN",
};
